import Tooltip from "../../generic-building-blocks/Tooltip";
import { useBulkSignalsInput } from "./utils";
import { ArchivedFilter } from "@avenueops/shared-types";
import { DropdownSelect } from "@avenueops/web-components";
import { OvalLoader } from "@avenueops/web-components";
import { WrenchIcon } from "@heroicons/react/24/outline";
import { DynamicStatus, ProcessStatus } from "@prisma/client";
import { useDeselectAll } from "context/BulkActionsContext";
import _ from "lodash";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { useBulkSetStatusMutation } from "utils/state/processes";
import { noOp } from "utils/state/utils";
import { trpc2 } from "utils/trpc";

interface Props {
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export default function ProcessTableStatusDropdown({ archived, isDashboard }: Props) {
  // Get status options for that organization and sort based on open/terminal state/intermediary
  const { isLoading, data: statuses } = trpc2.v2.dynamicStatus.list.useQuery();
  const deselectAll = useDeselectAll();

  // Sort by having Open first, terminalState last and everything else in the middle
  const compareStatus = (status1: DynamicStatus, status2: DynamicStatus) => {
    const score1: number = status1.label === "Open" ? 0 : status1.terminalState ? 1 : 0.5;
    const score2: number = status1.label === "Open" ? 0 : status2.terminalState ? 1 : 0.5;
    return score1 - score2;
  };

  const options =
    statuses
      ?.sort((a: DynamicStatus, b: DynamicStatus) => compareStatus(a, b))
      .map((status: DynamicStatus) => ({
        label: status.label,
        value: status.id,
        icon: <div className="rounded-full h-4 w-4" style={{ backgroundColor: status.color }}></div>,
      })) ?? [];

  const bulkSignalsInput = useBulkSignalsInput({ archived, isDashboard });

  const { mutateAsync: bulkSetStatus } = useBulkSetStatusMutation({
    onSuccess: async () => {
      deselectAll();
    },
  });

  return (
    <Tooltip text="Set Status" justify={"CENTER"} width="FIT" duration="duration-[5ms]">
      {isLoading ? (
        <OvalLoader size={15} type="DEFAULT" />
      ) : (
        <DropdownSelect
          name="bulkStatus"
          options={options}
          type="ICON"
          IndicatorIcon={WrenchIcon}
          onChange={(value: string | undefined) => {
            if (value) {
              bulkSetStatus({
                bulkSignalsInput,
                statusId: value,
              }).catch(noOp);
            }
          }}
        />
      )}
    </Tooltip>
  );
}
